import { provideHttpClient, withInterceptors } from '@angular/common/http'

import { authInterceptor } from './auth.interceptor'
import { errorInterceptor } from './error.interceptor'

export const provideHttp = () =>
  provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]))
